export default "__VITE_ASSET__DrZXNTqp__"